export enum AccessModule {
  CALENDAR = 'calendar',
  FILES = 'files',
  PROFILE = 'profile',
  MEASUREMENTS = 'measurements',
  NUTRITION = 'nutrition',
}

export enum AccessPermission {
  READ = 'read',
  WRITE = 'write',
}

export interface UserPermission {
  id: number;
  granterId: number;
  granteeId: number;
  moduleCode: AccessModule;
  permissions: AccessPermission[];
  expiresAt: string | null;
  isActive: boolean;
  notes?: string;
  grantee?: { id: number; firstName: string; lastName: string; };
  granter?: { id: number; firstName: string; lastName: string; };
}

export interface GrantAccessPayload {
  granteeId: number;
  moduleCode: AccessModule;
  permissions: AccessPermission[];
  expiresAt?: string | null;
  notes?: string;
}

// --- Permissions API ---

export interface BasePermissionType {
  code: string;
  label: string;
}

export interface PermissionTypeItem extends BasePermissionType {
  isDefault: boolean;
}

export interface GrantedPermissionTypeItem extends BasePermissionType {
  isGranted: boolean;
}

interface ModulePermissions<T extends BasePermissionType> {
  code: string;
  label: string;
  permissions: T[];
}

export type PermissionItem = ModulePermissions<PermissionTypeItem>;
export type GrantedToItem = ModulePermissions<GrantedPermissionTypeItem>;

export interface PatchGrantedToItem {
  code: string;
  permissions: Pick<GrantedPermissionTypeItem, 'code' | 'isGranted'>[];
}

export interface ConnectionAccessItem {
  code: string;
  permissions: string[];
}
